<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" :title="title" width="500" >
      <el-form  :model="formInline" class="demo-form-inline">
        <el-form-item label="密码">
          <el-input style="width:200px" v-model="formInline.pwd" placeholder="请输入密码" clearable />
        </el-form-item>
        <el-form-item label="重复密码">
          <el-input style="width:200px"  v-model="formInline.repwd" placeholder="请再次输入密码" clearable />
        </el-form-item>
        <el-form-item >
          <el-button style="margin: 0 auto" type="primary" @click="uodatePwd">修改密码</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog, ElForm, ElFormItem, ElButton, ElInput, ElMessage} from "element-plus";
import {updatePwd,updateOtherPwd} from "@/utils/api"
export default {
  components:{ElDialog, ElForm, ElFormItem, ElButton, ElInput},
  name: 'UpdatePwd',
  data(){
    return{
      dialogTableVisible:false,
      formInline:{}
    }
  },
  methods:{
    open(data){
      this.dialogTableVisible=true
      if(data && data.id){
        this.formInline.id = data.id
      }else {
        this.formInline ={}
      }
    },
    uodatePwd(){
      if(!this.formInline.pwd  ){
        ElMessage.warning('请输入密码')
        return
      }
      if(!this.formInline.repwd  ){
        ElMessage.warning('请重复输入密码')
        return
      }
      if(this.formInline.pwd !=this.formInline.repwd ){
        ElMessage.warning('2次密码不一致')
        return
      }
      if(!this.formInline.id){
        updatePwd(this.formInline).then(res=>{
          this.dialogTableVisible=false
          console.log(res)
          ElMessage.success('修改成功')
          localStorage.clear()
          window.location.href = "/"
        }).catch(err=>{
          ElMessage.error(err)
        })
      }else{
        updateOtherPwd(this.formInline).then(res=>{
          console.log(res)
          ElMessage.success('修改成功')
          this.dialogTableVisible=false
        }).catch(err=>{
          ElMessage.error(err)
        })
      }


    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
</style>